import axios from "axios";
import { api } from "../config";
import { getAuthToken } from "../Api/common";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// Dynamic authorization interceptor
axios.interceptors.request.use(
  function (config) {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("server-online"));
    }

    if (response.data && response.data.code) {
      if (response.data.code === 403) {
        return Promise.reject({
          message: "Forbidden: You don't have access.",
          code: 403,
        });
      }
    }

    return response.data ? response.data : response;
  },

  function (error) {
    if (
      axios.isCancel(error) ||
      error?.name === "CanceledError" ||
      error?.code === "ERR_CANCELED" ||
      error?.message === "canceled"
    ) {
      return Promise.reject(error);
    }

    // Detect server down / offline when no HTTP response is received
    if (
      !error?.response &&
      (error?.code === "ERR_NETWORK" ||
        error?.code === "ECONNREFUSED" ||
        error?.message === "Network Error" ||
        error?.message?.includes("Network Error"))
    ) {
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("server-offline"));
      }
    }

    // Extract server-provided error message if available
    const serverMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      (typeof error?.response?.data === "string" ? error.response.data : null);

    const status = error?.response?.status || error?.status;
    const errorData = error?.response?.data;

    // Auto logout if session expired or token is invalid
    const isTokenExpired =
      (status === 401 && (errorData?.expired || errorData?.message === "Session expired" || errorData?.message === "Token is missing or unauthorized")) ||
      (status === 403 && (errorData?.message?.includes("Forbidden") || errorData?.error?.name === "TokenExpiredError"));

    if (isTokenExpired) {
      localStorage.clear();
      const currentPath = window.location.pathname;
      if (currentPath !== "/login" && !currentPath.startsWith("/auth-")) {
        window.location.href = "/login";
      }
    }

    let fallbackMessage;
    switch (status) {
      case 500:
        fallbackMessage = "Internal Server Error";
        break;
      case 401:
        fallbackMessage = "Invalid credentials";
        break;
      case 404:
        fallbackMessage = "Sorry! the data you are looking for could not be found";
        break;
      default:
        fallbackMessage = error?.message || "An error occurred";
    }

    const finalMessage = serverMessage || fallbackMessage;

    if (error && typeof error === "object") {
      error.message = finalMessage;
      return Promise.reject(error);
    }

    return Promise.reject(new Error(finalMessage));
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */

const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("token");
  // const userData = useSelector

  if (!user) {
    return null;
  } else {
    try {
      return user;
    } catch (error) {
      return false;
    }
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
